import moment from 'moment-mini';
import { IChallengeResponse, SortDirection } from '@joc/api-gateway';

export enum CHALLENGE_PHASE {
	OPEN = 'OPEN',
	CLOSED = 'CLOSED',
	SCHEDULED = 'SCHEDULED',
}

export type ChallengePhaseSource = Pick<IChallengeResponse, 'startDate' | 'endDate'>;

export const getChallengePhase = (challenge: ChallengePhaseSource): CHALLENGE_PHASE => {
	const now = moment();

	if (now.isAfter(moment(challenge.endDate))) {
		return CHALLENGE_PHASE.CLOSED;
	}

	if (now.isBefore(moment(challenge.startDate))) {
		return CHALLENGE_PHASE.SCHEDULED;
	}

	return CHALLENGE_PHASE.OPEN;
};

const CHALLENGE_PHASE_SORT_ORDER: Record<CHALLENGE_PHASE, number> = {
	[CHALLENGE_PHASE.SCHEDULED]: 0,
	[CHALLENGE_PHASE.OPEN]: 1,
	[CHALLENGE_PHASE.CLOSED]: 2,
};

export const compareChallengesByPhase = (
	a: ChallengePhaseSource,
	b: ChallengePhaseSource,
	sortDir: SortDirection
): number => {
	const diff = CHALLENGE_PHASE_SORT_ORDER[getChallengePhase(a)] - CHALLENGE_PHASE_SORT_ORDER[getChallengePhase(b)];

	return sortDir === SortDirection.ASC ? diff : -diff;
};

export const CHALLENGE_TABLE_SORT = {
	PHASE: 'phase',
} as const;

export type ChallengeTableSortBy = (typeof CHALLENGE_TABLE_SORT)[keyof typeof CHALLENGE_TABLE_SORT];

export type ChallengeTableSort = {
	sortBy: ChallengeTableSortBy;
	sortDir: SortDirection;
};
